import { IOrder } from "../Order/Order";
import { IPatient } from "../Patient";
import { IPayer } from "../Payers/Payers";
import { IResponse } from "../Response";

export enum AbnTemplateType {
  ABN_Medicare = "ABN_Medicare",
  ABN_Commercial = "ABN_Commercial",
  ABN_UhcMedicareAdvantage = "ABN_UhcMedicareAdvantage",
}

export enum AbnOption {
  BillMedicare = "BillMedicare",
  SelfPay = "SelfPay",
  DeclineService = "DeclineService",
  PayNowAndFileInsurance = "PayNowAndFileInsurance",
  SelfPayNoInsurance = "SelfPayNoInsurance",
  DeclineWithoutFinancialResponsibility = "DeclineWithoutFinancialResponsibility",
  CosmeticService = "CosmeticService",
}

export enum AbnVoidReasonCode {
  CptChanged = "CptChanged",
}

export interface IOptionDto {
  title?: string;
  label: string;
  value: string;
  /**
   * CLE-2659: leading portion of `label` that CMS-R-131 prints in bold. Presentational only, and
   * always a literal prefix of `label`. Absent on ABNs signed before this was introduced.
   */
  boldPrefix?: string;
}

export interface IDocumentHashDataDto {
  availableOptions: IOptionDto[];
  selectedOption: IOptionDto;
  reason?: string;
  note?: string;
}

export interface IAbnNoticeDocumentSnapshot {
  availableOptions: IOptionDto[];
  selectedOption: IOptionDto;
  procedures: any;
  reason?: string;
  note?: string;
}
export interface ICreateAbnNoticeRequest {
  orderId: string;
  signatureImageBase64: string;
  templateType: AbnTemplateType;
  abnOption: AbnOption;
  procedures: any; // JSON array/list of procedures
  documentHashData: IDocumentHashDataDto;
  signatureIpAddress?: string;
  userAgent?: string;
}

export interface IAbnNotice {
  id: string;
  patientId: string;
  orderId: string;
  payerId: number;
  signatureImageS3Key: string;
  imageByteSize: number;
  templateType: AbnTemplateType;
  abnOption: AbnOption;
  documentSnapshot: IAbnNoticeDocumentSnapshot;
  procedures: any; // JSON
  documentHash: string;
  imageHash?: string | null;
  signatureIpAddress?: string | null;
  userAgent?: string | null;
  isVoided: boolean;
  voidedAt?: string | null; // DateTime
  replacedById?: string | null;
  createdAt: string; // DateTime
  updatedAt: string; // DateTime
  patient?: IPatient;
  order?: IOrder;
  payer?: IPayer;
  replacedBy?: IAbnNotice | null;
  signatureUrl?: string | null;
}

export interface ICreateAbnNoticeResponse extends IResponse {
  data: IAbnNotice;
}
